import {
  FooterLink,
  FooterList,
  FooterNav,
  Footer as FuelFooter,
} from "@deere/fuel-react";
import { useTranslation } from "react-i18next";

interface FooterLinkItem {
  text: string;
  href: string;
}

const footerLinks: FooterLinkItem[] = [
  {
    text: "footer.links.privacyAndData",
    href: "https://www.deere.com/en/privacy-and-data/",
  },
  {
    text: "footer.links.termsOfUse",
    href: "https://www.deere.com/en/privacy-and-data/terms/",
  },
];

const Footer = () => {
  const { t } = useTranslation("common");
  const translatedFooterLinks = footerLinks.map((item) => ({
    ...item,
    text: t(item.text),
  }));

  return (
    <FuelFooter
      data-testid="parts-footer"
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        position: "relative",
        height: "120px",
      }}
    >
      <FooterNav aria-label="footer navigation">
        <FooterList>
          {translatedFooterLinks.map(({ text, href }) => (
            <FooterLink text={text} href={href} target="_blank" key={text} />
          ))}
        </FooterList>
      </FooterNav>
    </FuelFooter>
  );
};

export default Footer;
